import {
  DeleteApplicationDocument,
  DeleteApplicationMutation,
  DeleteApplicationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteApplication = () => {
  const [deleteApplicationMutation, { loading }] = useMutation(DeleteApplicationDocument, {
    extractorFn: (data: DeleteApplicationMutation) => data.atsMutations.deleteAtsApplication,
  })

  return {
    loading,
    deleteApplication(variables: DeleteApplicationMutationVariables) {
      return deleteApplicationMutation({
        variables,
        update(cache) {
          cache.evict({ id: cache.identify({ id: variables.id, __typename: 'AtsApplication' }) })
        },
      })
    },
  }
}
